import axios from "axios";
import { executeRefresh, clearRefreshPromise } from "./refreshtokenmanager";
import { ExtractSession } from "../useAuth/SessionExtract";
// we need to pass the baseURL as an object
// console.log("  token 4 axios ",localStorage.getItem('token'));
// console.log('fffffff',process.env);
const withToken = axios.create({
    baseURL: process.env.REACT_APP_BASE_URL,
    headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}`
    }
});
const withoutToken = axios.create({
    baseURL: process.env.REACT_APP_BASE_URL
});

// const withTokenUser = axios.create({
//     baseURL: process.env.REACT_APP_USER_STATION_URL,
//     headers: {
//         'Content-Type': 'application/json',
//         'Authorization': `Bearer ${localStorage.getItem('token')}`
//     }
// });
// const withoutTokenUser = axios.create({
//     baseURL: process.env.REACT_APP_USER_STATION_URL
// });
const actionTypes = ['RFS', 'ULD', 'EMAIL', 'ASR', 'SPL', 'HSR', 'airlinetoken', 'Trucking', 'TEMAIL', 'DVR', 'QMS', 'SAToken', 'QUT']; // , 'NO_TOKEN'
let keyType = null;
// Loop through the actionTypes array
for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    // Check if the current key matches any of the action keyTypes
    if (actionTypes.includes(key)) {
        keyType = key;
        break;
    }
}

const data = await ExtractSession("__A-");
const withRFSToken = axios.create({
    baseURL: process.env.REACT_APP_RFS_URL,
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json',
        'X-IWIT': data?.token
    }
});
withRFSToken.interceptors.response.use(
    (response) => response,
    async (error) => {
        const originalRequest = error.config;

        if (error.response?.status === 401 && !originalRequest._retry) {
            originalRequest._retry = true;

            try {
                await executeRefresh();
                return withRFSToken(originalRequest);
            } catch (refreshError) {
                clearRefreshPromise();
                window.location.href = '/Login';
                return Promise.reject(refreshError);
            }
        }

        return Promise.reject(error);
    }
);
const withEmailToken = axios.create({
    baseURL: process.env.REACT_APP_RFS_URL,
    headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${data?.EMAIL}`
    }
});
const withTemailToken = axios.create({
    baseURL: process.env.REACT_APP_RFS_URL,
    headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${data?.TEMAIL}`
    }
});
const key = localStorage.getItem('key');
const withDVRToken = axios.create({
    baseURL: process.env.REACT_APP_RFS_URL,
    headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${data?.NO_TOKEN}`,
        key: `${data?.key}`,
    }
});
const withoutRFSToken = axios.create({
    baseURL: process.env.REACT_APP_RFS_URL,
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    }
});
// withoutRFSToken.interceptors.response.use(
//     (response) => response,
//     async (error) => {
//         const originalRequest = error.config;

//         if (error.response?.status === 401 && !originalRequest._retry) {
//             originalRequest._retry = true;

//             try {
//                 // Cookie is sent automatically via withCredentials
//                 await axios.post(
//                     `${process.env.REACT_APP_RFS_URL}/refresh`,
//                     {},
//                     { withCredentials: true }
//                 );

//                 // Retry original request — cookie is now refreshed
//                 return withRFSToken(originalRequest);
//             } catch (refreshError) {
//                 window.location.href = '/login';
//                 return Promise.reject(refreshError);
//             }
//         }

//         return Promise.reject(error);
//     }
// );

const withULDToken = axios.create({
    baseURL: process.env.REACT_APP_RFS_URL,
    headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('ULD')}`
    }
});
const withoutULDToken = axios.create({
    baseURL: process.env.REACT_APP_RFS_URL
});
// export default withToken;
export { withToken, withoutToken, withRFSToken, withoutRFSToken, withEmailToken, withTemailToken, withDVRToken };
